// Formatos de los reportes (es-CO).
const n0 = new Intl.NumberFormat('es-CO');
const n1 = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 1, minimumFractionDigits: 1 });

export const F = {
  n: (v: number) => n0.format(Math.round(v)),
  p: (v: number) => `${n1.format(v)} %`,
  d1: (v: number) => n1.format(v),
  cop: (v: number) => `$ ${n0.format(Math.round(v))}`,
  dur(s: number) {
    s = Math.round(s);
    const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
    return h ? `${h} h ${String(m).padStart(2, '0')} min` : `${m}:${String(x).padStart(2, '0')}`;
  },
  durCorta: (s: number) => (s >= 3600 ? `${n1.format(s / 3600)} h` : s >= 60 ? `${Math.round(s / 60)} min` : `${Math.round(s)} s`),
  horas: (s: number) => `${n1.format(s / 3600)} h`,
};

export function pasoBonito(v: number) {
  const p = Math.pow(10, Math.floor(Math.log10(Math.max(v, 1e-9))));
  const f = v / p;
  return (f <= 1 ? 1 : f <= 2 ? 2 : f <= 2.5 ? 2.5 : f <= 5 ? 5 : 10) * p;
}

// Colores para series sin significado propio (siguen el tono de la paleta elegida).
export const SERIE = ['var(--acc)', 'oklch(.72 .13 200)', 'oklch(.78 .14 75)', 'oklch(.66 .16 330)', 'oklch(.68 .13 150)', 'oklch(.6 .05 272)'];
